<template>
  <div>

    <app-back-button
      route-name="subpropertyPeople"
      :route-params="{ tabName: 'players'}"
      i18n-code="entities.player.label"
    />
    <div class="app-content-page">
      <!-- Player view -->
      <app-player-view-profile  
        v-if="!tabs.profile.isDisabled && activeTabIndex === tabs.profile.index" 
        :id="id"
        :subpropertyId="subpropertyId"
      />

      <!-- Inscription list -->
      <app-player-view-inscriptions
        v-if="!tabs.inscription.isDisabled && activeTabIndex === tabs.inscription.index"
        :id="id"
        :subpropertyId="subpropertyId"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { i18n } from '@shared/i18n';

import PlayerViewToolbar from '@modules/player/components/player-view-toolbar.vue';
import PlayerViewProfile from '@modules/player/components/player-view-profile.vue';
import PlayerViewInscriptions from '@modules/player/components/player-view-inscriptions.vue';

export default {
  name: 'app-player-view-page',

  props: ['id', 'tabName'],

  computed: {
    ...mapGetters({
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      currentManage: 'auth/manage/currentManage',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
    }),

    enabledTabList() {
      return Object.values(this.tabs).filter((elem) => {
          return elem.isDisabled == false;
        },
      );
    },

    subpropertyId() {
      if(!this.currentManage) return null
      if(!this.currentManage.subproperty) return null
      if(!this.currentManage.subproperty.id) return null
      return this.currentManage.subproperty.id;
    }, 

    tabs() {
      return {
        profile: {
          isDisabled: false,
          type: 'profile',
          label: i18n('entities.player.view.tabs.profile'),
          index: 0,
          routerPush: {
            name: 'playerView',
            params: {
              id: this.id,
              tabName: 'profile',
            },
          },
        },
        inscription: {
          isDisabled: this.isPropertyNBA,
          type: 'inscription',
          label: i18n('entities.player.view.tabs.inscription'),
          index: 1,
          routerPush: {
            name: 'playerView',
            params: {
              id: this.id,
              tabName: 'inscription',
            },
          },
        },
      }
    }
  },


  mounted() {
    this.setTabs(this.enabledTabList);
    this.parseActiveTab();
  },

  beforeDestroy() {
    this.resetTabs();
  },

  methods: {
    ...mapActions({
      doFind: 'player/view/doFind',
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex:'layout/headerTabs/setActiveTabIndex',
      resetTabs: 'layout/headerTabs/resetTabs',
    }),

    parseActiveTab() {
      const routeTabIndex = this.$route.params.tabName;

      if (routeTabIndex) {
        this.setActiveTabIndex(
          this.tabs[routeTabIndex].index,
        );
      } else {
        this.setActiveTabIndex(
          Object.values(this.tabs)[0].index,
        );
      }

    },
  },

  components: {
    [PlayerViewToolbar.name]: PlayerViewToolbar,
    [PlayerViewProfile.name]: PlayerViewProfile,
    [PlayerViewInscriptions.name]: PlayerViewInscriptions,
  },
};
</script>
